import React, { Component } from 'react';
import StarShapes from '../body/main/shapes/stars/StarShapes'
import FlowerShapes from '../body/main/shapes/flowers/FlowerShapes'
import RectShapes from '../body/main/shapes/rectangles/RectShapes'
import ComplexShapes from '../body/main/shapes/complex/ComplexShapes'
import LineShapes from '../body/main/shapes/lines/LineShapes'
import Tutorial from './Tutorial'
import Text from '../body/main/shapes/text/Text'

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

 class Sidebar extends Component {
  
StarShapes() {
    return <span >Star</span>;
  }
  
 
  
  FlowerShapes() {
    return <span>Flower</span>;
  }
  RectShapes() {
    return <span>Rect</span>;
  }

  ComplexShapes() {
    return <span>Complex</span>;
  }
  LineShapes() {
    return <span>Line</span>;
  }
  Tutorial() {
    return <span>Tutorial</span>;
  }
  Text() {
    return <span>Text</span>;
  }
  
  
   render(){

    return (
      <Router>
        <div id="sidebar" className=" container-fluid d-flex justify-content-space-around text-center row col-12">
          <div className="col-2 text-left">
          <span className="bg-dark text-white offset-2" data-toggle="collapse" data-target="#sidebar-left" >
              <i className="fa fa-angle-double-left" aria-hidden="true"></i> {' '}Shapes
            </span>
         
          <nav id="sidebar-left" >
           
            <ul>
              <li>
                <Link to="/star"><span type="button"><i className="fa fa-star text-dark" aria-hidden="true"></i></span></Link>
              </li>
              <li>
                <Link to="/flower"><span type="button"><i className="fa fa-pagelines text-dark" aria-hidden="true"></i></span></Link>
              </li>
              <li>
                <Link to="/rectangle"><span type="button"><i className="fa fa-square text-dark" aria-hidden="true"></i></span></Link>
              </li>
              <li>
                <Link to="/complex"><span className="badge  text-dark" type="button"> <i className="fa fa- text-dark" aria-hidden="true">C</i></span></Link>
              </li>
              <li>
                <Link to="/line"><span type="button"><i className="fa fa-bars text-dark" aria-hidden="true"></i></span></Link>
              </li>
              <li>
                <Link to="/text"><span type="button"><i className="fa fa-text-height text-dark" aria-hidden="true"></i></span></Link>
              </li>
            </ul>
          </nav>
          </div>
  
          {/* A <Switch> looks through its children <Route>s and
              renders the first one that matches the current URL. */}
             <div className="col-md-8 text-center mr-0 ">
             <Switch>
             <Route exact path="/">
              <Tutorial />
            </Route>
            <Route  path="/star">
              <StarShapes />
            </Route>
            <Route path="/flower">
              <FlowerShapes />
            </Route>
            <Route path="/rectangle">
              <RectShapes />
            </Route>
            <Route path="/complex">
              <ComplexShapes />
            </Route>
            <Route path="/line">
              <LineShapes />
            </Route>
            <Route path="/tutorial">
              <Tutorial />
            </Route>
            <Route path="/text">
              <Text />
            </Route>
            
          </Switch>
             </div>
         
        </div>
      </Router>

   
    )
   }
}

export default Sidebar;

